module.exports = __webpack_public_path__ + "static/img/buybuybuy.81fc0ad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buybuybuy.gif
// module id = 3ym6
// module chunks = 1